import type { SVGProps } from 'react';

const SvgRaApproved = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M21.05 10.25A2.98 2.98 0 0 0 18.62 9h-2.61V5.23a2.7 2.7 0 0 0-1.85-2.57c-.74-.25-1.54-.16-2.21.23s-1.14 1.05-1.3 1.86l-.08.54A7.16 7.16 0 0 1 7.69 10H5.02c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h11.22c1.72 0 3.25-1.1 3.79-2.73l1.44-4.32c.31-.93.16-1.91-.41-2.7zM7 18H5v-6h2zm12.56-5.68-1.44 4.32a1.99 1.99 0 0 1-1.9 1.37H9v-6.48a9.19 9.19 0 0 0 3.53-5.93l.07-.49c.05-.27.23-.41.34-.47s.31-.15.58-.06c.29.1.48.37.48.67v3.77c0 1.1.9 2 2 2h2.61c.33 0 .62.15.81.42.19.26.24.59.14.9z"
    />
  </svg>
);
export default SvgRaApproved;
